<div class="admin-stripe-container">
  <h3>Configuracion de Pagos &mdash; Stripe</h3>
  <p class="text-muted">Activa o desactiva el modo de pruebas de Stripe.</p>

  <!-- Loading -->
  <div *ngIf="cargando" class="alert alert-info">
    <i class="fa fa-spinner fa-spin"></i> Cargando configuracion...
  </div>

  <!-- Mensajes -->
  <div *ngIf="mensaje" class="alert alert-success alert-dismissible fade show" role="alert">
    {{ mensaje }}
    <button type="button" class="close" (click)="mensaje = null">&times;</button>
  </div>
  <div *ngIf="error" class="alert alert-danger alert-dismissible fade show" role="alert">
    {{ error }}
    <button type="button" class="close" (click)="error = null">&times;</button>
  </div>

  <!-- Card de configuracion -->
  <div class="card" *ngIf="!cargando">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-md-8">
          <h5 class="card-title">
            Modo actual:
            <span [class.text-success]="currentMode === 'live'"
                  [class.text-warning]="currentMode === 'test'">
              <strong>{{ currentMode === 'live' ? 'LIVE (Produccion)' : 'TEST (Pruebas)' }}</strong>
            </span>
          </h5>
          <p class="card-text">
            <small class="text-muted">
              Las claves se configuran en <a routerLink="/admin/config">Admin &gt; Configuracion</a>
            </small>
          </p>
        </div>
        <div class="col-md-4 text-right">
          <button class="btn btn-lg"
                  [class.btn-danger]="currentMode === 'live'"
                  [class.btn-success]="currentMode === 'test'"
                  [disabled]="cambiando"
                  (click)="toggleMode()">
            <i class="fa" [class.fa-exchange]="!cambiando" [class.fa-spinner]="cambiando" [class.fa-spin]="cambiando"></i>
            {{ cambiando ? 'Cambiando...' : (currentMode === 'live' ? 'Cambiar a TEST' : 'Cambiar a LIVE') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Advertencia modo live -->
  <div class="alert alert-warning mt-3" *ngIf="currentMode === 'live' && !cargando">
    <i class="fa fa-exclamation-triangle"></i>
    <strong>Atencion:</strong> El modo LIVE realiza cobros reales. Asegurate de tener configuradas las claves de produccion en <a routerLink="/admin/config">Admin &gt; Configuracion</a> antes de usar este modo.
  </div>

  <!-- Info modo test -->
  <div class="alert alert-info mt-3" *ngIf="currentMode === 'test' && !cargando">
    <i class="fa fa-info-circle"></i>
    <strong>Modo prueba:</strong> Usa las tarjetas de prueba de Stripe:
    <ul class="mb-0 mt-2">
      <li>Exito: <code>4242 4242 4242 4242</code></li>
      <li>Requiere 3D Secure: <code>4000 0025 0000 3155</code></li>
      <li>Fallo: <code>4000 0000 0000 0002</code></li>
      <li>Cualquier fecha futura y cualquier CVC</li>
    </ul>
  </div>
</div>
